export default __webpack_public_path__ + "static/media/B4_13.93e6cd7b.mp3";